/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Icon from "../common/Icon.vue";
import appConfig from "../../api/appConfig";
import { mapGetters, mapActions } from "vuex";
import $ from 'jquery'

const __vue_script__ = {
  name: "ModalShop",
  components: {
    Icon,
  },
  props: [
    "content",
    "email",
    "facebook",
    "images",
    "phone",
    "title",
    "website",
    "location",
    "id",
    "variation",
    "rooms",
  ],
  computed: {
    ...mapGetters({
      strings: "content",
    }),
    shouldShowOffersButton() {
      return this.variation !== 'offer' && this.$store.getters.specialOfferById(this.id);
    },
    shouldShowPathFinderButton() {
      return this.variation !== 'offer';
    },
  },
  mounted() {
    this.$nextTick(function() {
      $(this.$el)
        .find(".js-slider")
        .slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
          fade: true,
          autoplay: true,
          autoplaySpeed: appConfig.sliderSpeed || 1000,
          pauseOnFocus: false,
          pauseOnHover: false,
        });
    });
  },
  destroyed() {
    $(this.$el)
      .find(".js-slider")
      .slick("unslick");
  },
  methods: {
    showOnFloorPlan(shopId) {
      this.$store.dispatch("hideOffersModal");
      this.$store.dispatch("hideShopModal", shopId);
      this.$store.dispatch("selectShop", shopId);
    },
    showSpecialOffer(shopId) {
      this.$store.dispatch("selectShop", shopId);
      this.$store.dispatch("changeModalOffer", shopId);
      this.$store.dispatch("showOffersModal");
    },
    startPathFinder(shopId) {
      this.$store.dispatch("hideOffersModal");
      this.$store.dispatch("hideShopModal", shopId);
      this.$store.dispatch("updatePathFinderTargetShop", shopId);
    },
  },
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modalShop" }, [
    _c("div", { staticClass: "modalShop_header" }, [
      _c("h2", { staticClass: "modalShop_title" }, [
        _c("span", { domProps: { innerHTML: _vm._s(_vm.title) } }),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modalShop_colWrap" }, [
      _c("div", { staticClass: "modalShop_imageCol" }, [
        _c("div", { staticClass: "modalShop_slider" }, [
          _c(
            "div",
            { staticClass: "modalShop_slides js-slider" },
            _vm._l(_vm.images, function (image, index) {
              return image
                ? _c("div", { key: index, staticClass: "modalShop_slide" }, [
                    _c("img", {
                      staticClass: "modalShop_image",
                      attrs: { src: image.business_image_lg },
                    }),
                  ])
                : _vm._e()
            }),
            0
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modalShop_textCol" }, [
        _c("div", { staticClass: "modalShop_infoCol" }, [
          _c("div", { staticClass: "infoList" }, [
            _c("div", { staticClass: "infoList_item infoList_item-padRight" }, [
              _vm._v(_vm._s(_vm.location)),
            ]),
            _vm._v(" "),
            _vm.shouldShowPathFinderButton
              ? _c("div", { staticClass: "infoList_item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "goLink",
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.startPathFinder(_vm.id)
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "goLink_text" }, [
                        _vm._v(_vm._s(_vm.strings.show_path)),
                      ]),
                      _vm._v(" "),
                      _c("svg", { staticClass: "goLink_icon" }, [
                        _c("use", {
                          attrs: {
                            "xmlns:xlink": "http://www.w3.org/1999/xlink",
                            "xlink:href": "#shape-arrow-right",
                          },
                        }),
                      ]),
                    ]
                  ),
                ])
              : _vm.rooms && _vm.rooms.length > 0
              ? _c("div", { staticClass: "infoList_item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "goLink",
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.showOnFloorPlan(_vm.id)
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "goLink_text" }, [
                        _vm._v(_vm._s(_vm.strings.show_on_floorplan)),
                      ]),
                      _vm._v(" "),
                      _c("svg", { staticClass: "goLink_icon" }, [
                        _c("use", {
                          attrs: {
                            "xmlns:xlink": "http://www.w3.org/1999/xlink",
                            "xlink:href": "#shape-arrow-right",
                          },
                        }),
                      ]),
                    ]
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modalShop_text" }, [
        _c("span", { domProps: { innerHTML: _vm._s(_vm.content) } }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modalShop_footer" }, [
        _c("div", { staticClass: "modalShop_footerContent" }, [
          _c("div", { staticClass: "modalShop_infoCol" }, [
            _c("ul", { staticClass: "infoList" }, [
              _vm.phone
                ? _c("li", { staticClass: "infoList_item" }, [
                    _c("div", { staticClass: "iconText" }, [
                      _c(
                        "div",
                        { staticClass: "iconText_icon iconText_icon-phone" },
                        [_c("Icon", { attrs: { "icon-name": "phone" } })],
                        1
                      ),
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.phone) +
                          "\n              "
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.email
                ? _c("li", { staticClass: "infoList_item" }, [
                    _c("div", { staticClass: "iconText" }, [
                      _c(
                        "div",
                        { staticClass: "iconText_icon iconText_icon-mail" },
                        [_c("Icon", { attrs: { "icon-name": "mail" } })],
                        1
                      ),
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.email) +
                          "\n              "
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.website
                ? _c("li", { staticClass: "infoList_item" }, [
                    _c("div", { staticClass: "iconText" }, [
                      _c(
                        "div",
                        { staticClass: "iconText_icon iconText_icon-browser" },
                        [_c("Icon", { attrs: { "icon-name": "browser" } })],
                        1
                      ),
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.website) +
                          "\n              "
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.facebook
                ? _c("li", { staticClass: "infoList_item" }, [
                    _c("div", { staticClass: "iconText" }, [
                      _c(
                        "div",
                        { staticClass: "iconText_icon iconText_icon-facebook" },
                        [_c("Icon", { attrs: { "icon-name": "facebook" } })],
                        1
                      ),
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.facebook) +
                          "\n              "
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm.shouldShowOffersButton
              ? _c("div", { staticClass: "modalShop_ctaButton" }, [
                  _c(
                    "button",
                    {
                      staticClass: "bigButton",
                      on: {
                        click: function ($event) {
                          return _vm.showSpecialOffer(_vm.id)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "bigButton_content" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.strings.view_special_offer) +
                            "\n              "
                        ),
                      ]),
                    ]
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
    ]),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "resources/kiosk/scripts/components/modals/ModalShop.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__